if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

        // Sync add-on forms with main event selected variant on load (e.g. ?variant=...) – defer so add-on section is in DOM
        setTimeout(() => this.syncAddOnsToMainEventVariant(), 150);

        // On add-on form submit, sync variant and Main Event details from current main event (runs before product-form handler)
        this._addOnSubmitSync = this._syncAddOnFormOnSubmit.bind(this);
        document.addEventListener('submit', this._addOnSubmitSync, true);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event.data.variant;
          if (!variant) return;
          const variantTitle = variant.public_title || variant.title;
          document.querySelectorAll('.parent_product_variant_details').forEach((input) => {
            if (input) input.value = variantTitle;
          });
          document.querySelectorAll('.main-event-key-input').forEach((input) => {
            if (input) input.value = `${this.dataset.productName} - ${variantTitle}`;
          });

          // Keep add-ons synced to selected event variant.
          // Add-ons are now surfaced via popup after event add-to-cart.
          if (this.dataset.productType === 'Ticket') {
            setTimeout(() => this.syncAddOnsToMainEventVariant(variant), 0);
          }
        });

        // No longer toggling add-on add-to-cart visibility based on cart state.
        // (Popup flow handles when add-ons are shown to the user.)
      }

      getCookie(cname) {
        let name = cname + '=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return '';
      }

      buildInventoryUI(data) {
        const wrapper = document.querySelector('.inventory-location-wrapper');
        if (!wrapper) return;

        const badgeWrapper = document.querySelector('.product__info-container .badges-wrapper');
        if (badgeWrapper) badgeWrapper.innerHTML = '';

        const productForm = document.querySelector('.product__info-container product-form.product-form form');
        const variantInput = productForm?.querySelector('input[name="id"]');
        const addToCartButton = productForm?.querySelector('.product-form__buttons button');

        let shopLocation = data.find((item) => item.location === 'Shop location');
        let hasShopLocation = !!shopLocation;
        let pickupLocations = data.filter((item) => item.location !== 'Shop location');
        let firstPickup = pickupLocations[0];

        wrapper.innerHTML = '';
        let cookieLocation = getCookie('product_location') || 'Shop location';
        console.log("cookieLocation::",cookieLocation);
        const d = new Date();
        d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
        let expires = 'expires=' + d.toUTCString();
        document.cookie = 'product_location' + '=' + cookieLocation + ';' + expires + ';path=/';
        // cartValidate();
        // === Ship to Me ===
        if (hasShopLocation && !pickupLocations.length) {
          let isSoldOut = shopLocation.quantity == 0;
          updateSoldOutUI(isSoldOut);
          // updateLowStockIndicator(shopLocation.quantity);
          setMaxQuantity(shopLocation.quantity);
          // updateInventoryMessage(shopLocation.quantity);
        }
        if (hasShopLocation && pickupLocations.length > 0) {
          let isSoldOut = shopLocation.quantity == 0;
          let shipToMe = document.createElement('div');
          shipToMe.innerHTML = `
          <label>
            <input type="radio" name="delivery_option" value="ship" ${!isSoldOut ? 'checked' : ''}>
            Ship to me<br>
            <small>Shipping calculated at checkout</small>
          </label>
        `;
          wrapper.appendChild(shipToMe);
          if (!pickupLocations.length) {
            updateSoldOutUI(isSoldOut);
            // updateLowStockIndicator(shopLocation.quantity);
            setMaxQuantity(shopLocation.quantity);
            // updateInventoryMessage(shopLocation.quantity);
          }
        }

        // === Location Pickup ===
        if (pickupLocations.length > 0) {
          const pickupOption = document.createElement('div');
          pickupOption.innerHTML = `
          <label>
            <input type="radio" name="delivery_option" value="pickup" ${
              cookieLocation !== 'Shop location' ? 'checked' : ''
            }>
            Location Pickup<br>
            <small>
              <span id="selected-pickup-location">${
                cookieLocation !== 'Shop location' ? cookieLocation : firstPickup.location
              }</span>
              <a href="#" id="view-locations" style="margin-left:10px; text-decoration:underline; cursor:pointer;">Change Location</a>
            </small>
          </label>
        `;
          wrapper.appendChild(pickupOption);

          const modal = document.createElement('div');
          modal.id = 'pickup-modal';
          modal.style.cssText = `
          display: none; position: fixed; top: 0; left: 0;
          width: 100%; height: 100%; background: rgba(0,0,0,0.6);
          z-index: 9999;
        `;
          pickupLocations = pickupLocations.filter((item)=> item.location != "Shop location");
          modal.innerHTML = `
          <div class="pickup-modal-inner">
            <div class="pickup-modal-wrapper">
              <div class="pickup-modal-heading">
                <h3 class="h2 color-secondary">Select A Pickup Location</h3>
                <p class="font-size-18">This item is available for pickup at the following Duplin locations. Choose your preferred pickup spot.</p>
              </div>
              <ul style="list-style:none; padding:0;">
                ${pickupLocations
                  .map((loc, index) => {
                    const addr = loc.address || {};
                    const address1 = addr.address1 || '';
                    const address2 = addr.address2 || '';
                    const address3 = addr.address3 || '';
                    const isActive = index === 0 ? 'active' : '';
                    return `
                    <li class="${isActive}">
                      <div>
                        <strong>${loc.location}</strong><br>
                        <div style="margin-top:5px;">
                          ${address1}<br>
                          ${address2 ? `${address2}<br>` : ''}
                          ${address3}
                        </div>
                      </div>
                      <button class="select-pickup-btn button button--primary" 
                      data-location="${loc.location}" 
                      data-quantity="${loc.quantity}">Choose Location</button>
                    </li>
                  `;
                  })
                  .join('')}
              </ul>
              <button id="close-modal" style="margin-top:20px;">Close</button>
            </div>
          </div>
        `;
          document.body.appendChild(modal);

          document.getElementById('view-locations').addEventListener('click', (e) => {
            e.preventDefault();
            modal.style.display = 'block';
          });

          modal.querySelector('#close-modal').addEventListener('click', () => (modal.style.display = 'none'));
          modal.addEventListener('click', (e) => {
            if (e.target === modal) modal.style.display = 'none';
          });

          modal.querySelectorAll('.select-pickup-btn').forEach((button) => {
            button.addEventListener('click', (e) => {
              const location = e.target.dataset.location;
              const quantity = parseInt(e.target.dataset.quantity);
              // === Update selected location

              const d = new Date();
              d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
              let expires = 'expires=' + d.toUTCString();
              document.cookie = 'product_location' + '=' + location + ';' + expires + ';path=/';
              //cartValidate();

              document.getElementById('selected-pickup-location').textContent = location;
              document.querySelector('input[value="pickup"]').checked = true;

              // === Add active class to selected li
              const allLis = modal.querySelectorAll('li');
              allLis.forEach((li) => li.classList.remove('active')); // remove previous
              e.target.closest('li')?.classList.add('active'); // add to selected

              modal.style.display = 'none';

              updateSoldOutUI(quantity <= 0);
              // updateLowStockIndicator(quantity);
              setMaxQuantity(quantity);
              // updateInventoryMessage(quantity)
            });
          });

          if (!hasShopLocation || shopLocation.quantity <= 0) {
            updateSoldOutUI(firstPickup.quantity <= 0);
            // updateLowStockIndicator(firstPickup.quantity);
            setMaxQuantity(firstPickup.quantity);
            // updateInventoryMessage(firstPickup.quantity);
          }
        }

        // === Default selection check
        const radioInputs = wrapper.querySelectorAll('input[name="delivery_option"]');
        const oneChecked = Array.from(radioInputs).some((input) => input.checked);
        if (!oneChecked && radioInputs.length > 0) {
          radioInputs[0].checked = true;
        }

        let selectedOption = wrapper.querySelector('input[name="delivery_option"]:checked');
        if (selectedOption) {
          if (selectedOption.value === 'pickup') {
            const selected = document.getElementById('selected-pickup-location')?.textContent;
            const loc = pickupLocations.find((l) => l.location === selected) || firstPickup;
            updateSoldOutUI(loc.quantity <= 0);
            // updateLowStockIndicator(loc.quantity);
            setMaxQuantity(loc.quantity);
            // updateInventoryMessage(loc.quantity);
          } else {
            updateSoldOutUI(shopLocation?.quantity <= 0);
            // updateLowStockIndicator(shopLocation?.quantity);
            setMaxQuantity(shopLocation?.quantity);
            // updateInventoryMessage(shopLocation?.quantity);
          }
        }

        // === Change handler
        wrapper.querySelectorAll('input[name="delivery_option"]').forEach((input) => {
          input.addEventListener('change', () => {
            if (input.value === 'ship') {
              const d = new Date();
              d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
              let expires = 'expires=' + d.toUTCString();
              document.cookie = 'product_location' + '=' + 'Shop location' + ';' + expires + ';path=/';
              updateSoldOutUI(shopLocation?.quantity <= 0);
              // updateLowStockIndicator(shopLocation.quantity);
              setMaxQuantity(shopLocation.quantity);
              // updateInventoryMessage(shopLocation.quantity);
            } else {
              const selected = document.getElementById('selected-pickup-location')?.textContent;
              console.log("selected=>",selected)
              const d = new Date();
              d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
              let expires = 'expires=' + d.toUTCString();
              document.cookie = 'product_location' + '=' + selected + ';' + expires + ';path=/';
              const loc = pickupLocations.find((l) => l.location === selected);
              if (loc) {
                updateSoldOutUI(loc.quantity <= 0);
                // updateLowStockIndicator(loc.quantity);
                setMaxQuantity(loc.quantity);
                // updateInventoryMessage(loc.quantity);
              }
            }
          });
        });
      }

      updateSoldOutUI(isSoldOut) {
        const badgeWrapper = document.querySelector('.product__info-container .badges-wrapper');
        const productForm = document.querySelector('.product__info-container product-form.product-form form');
        const variantInput = productForm?.querySelector('input[name="id"]');
        const addToCartButton = productForm?.querySelector('.product-form__buttons button');

        if (badgeWrapper) {
          badgeWrapper.innerHTML = isSoldOut
            ? `<span class="badge price__badge-sold-out color-{{ settings.sold_out_badge_color_scheme }}">{{ 'products.product.sold_out' | t }}</span>`
            : '';
        }

        if (variantInput) {
          isSoldOut ? variantInput.setAttribute('disabled', 'disabled') : variantInput.removeAttribute('disabled');
        }

        if (addToCartButton) {
          isSoldOut
            ? addToCartButton.setAttribute('disabled', 'disabled')
            : addToCartButton.removeAttribute('disabled');
        }

        // check inventory of
      }

      updateLowStockIndicator(locationQuantity) {
        const inventoryDiv = document.querySelector('.product__info-container .product__inventory');
        if (!inventoryDiv) return;
        // const selectedInput = document.querySelector('input[name^="Select Pack Size"]:checked');
        // const selectedValue = selectedInput?.value?.trim();

        // {% if product_inventory_threshold != blank %}
        //   const threshold = {{ product_inventory_threshold }};
        // {% else %}
        //   const threshold = parseInt(inventoryDiv.dataset.productThreshold);
        // {% endif %};

        const showQty = inventoryDiv.dataset.show_inventory_quantity === 'true';
        const threshold = parseInt(inventoryDiv.dataset.productThreshold);

        // const isCase = selectedValue === 'Case';
        // const displayQty = isCase ? Math.floor(locationQuantity / 12) : locationQuantity;

        // Only show indicator if locationQuantity > 0 and <= threshold, and threshold is a valid number
        if (!isNaN(threshold) && locationQuantity > 0 && locationQuantity <= threshold) {
          const iconSvg = `
          <span class="svg-wrapper" style="color: rgb(238, 148, 65)">
            {{- 'icon-inventory-status.svg' | inline_asset_content -}}
          </span>
        `;

          const message = showQty
            ? `Hurry Up! Only ${locationQuantity} in Stock`
            : `{{- 'products.product.inventory_low_stock' | t -}}`;
          inventoryDiv.classList.remove('hidden');
          inventoryDiv.innerHTML = `${iconSvg} ${message}`;
        } else {
          inventoryDiv.innerHTML = '';
        }
      }

      setMaxQuantity(maxQty) {
        if (window.DuplinPack?.applyInventoryLimit(this, maxQty)) return;
        const quantityInputs = document.querySelectorAll('.price-per-item__container input.quantity__input');
        const productForm = document.querySelector('.product__info-container product-form.product-form form');
        const addToCartButton = productForm?.querySelector('.product-form__buttons button');

        // Get the selected input value (either "Single" or "Case")
        const selectedInput = document.querySelector('input[name^="Select Pack Size"]:checked');
        const selectedValue = selectedInput?.value?.trim();
        const isCaseVariant = selectedValue === 'Case';

        // Adjust quantity: divide by 12 if "Case"
        const adjustedQty = isCaseVariant ? Math.floor(maxQty / 12) : maxQty;
        quantityInputs.forEach((input) => {
          const cartQty = parseInt(input.getAttribute('data-cart-quantity')) || 0;

          const adjustedMax = Math.max(0, adjustedQty - cartQty);
          updateLowStockIndicator(adjustedMax);

          input.setAttribute('min', adjustedMax === 0 ? 0 : 1);
          input.setAttribute('max', adjustedMax);
          input.setAttribute('avail-qty', adjustedQty);

          // Adjust current input value
          let current = parseInt(input.value);
          if (isNaN(current) || current < (adjustedMax === 0 ? 0 : 1)) {
            current = adjustedMax === 0 ? 0 : 1;
          } else if (current > adjustedMax) {
            current = adjustedMax;
          }
          input.value = current;

          // Enable or disable Add to Cart
          if (addToCartButton) {
            if (adjustedMax === 0) {
              // addToCartButton.innerText = 'Sold out'
              addToCartButton.setAttribute('disabled', 'disabled');
            } else {
              addToCartButton.removeAttribute('disabled');
              // addToCartButton.innerText = 'Add to cart'
            }
          }

          // Trigger events for theme sync
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));

          // Prevent invalid manual input
          input.addEventListener('input', () => {
            const min = parseInt(input.getAttribute('min'));
            const max = parseInt(input.getAttribute('max'));
            let val = parseInt(input.value);
            // if (isNaN(val) || val < min) val = min;
            if (val > max) val = max;
            input.value = val;
          });
        });
      }

      updateInventoryMessage(originalQty) {
        const inventoryElement = document.querySelector('#Inventory-template--24364478857532__main');
        const threshold = parseInt(inventoryElement?.dataset?.productThreshold || 10);

        // Get the selected value ("Single" or "Case")
        const selectedInput = document.querySelector('input[name^="Select Pack Size"]:checked');
        const selectedValue = selectedInput?.value?.trim();
        const isCase = selectedValue === 'Case';
        // Adjust the quantity for case display
        const displayQty = isCase ? Math.floor(originalQty / 12) : originalQty;
        // Update the message
        if (isCase) {
          if (Number(originalQty) && !displayQty) {
            inventoryElement.innerHTML = `
                <span class="svg-wrapper" style="color: rgb(238, 148, 65)">
                  <svg class="icon icon-inventory-status" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="7.09011" cy="7.06177" rx="7.09011" ry="7" fill="#50C1BC" />
                  </svg>
                </span>
                Out of Stock
              `;
          } else if (inventoryElement && Number(originalQty) && displayQty <= threshold) {
            inventoryElement.innerHTML = `
                <span class="svg-wrapper" style="color: rgb(238, 148, 65)">
                  <svg class="icon icon-inventory-status" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="7.09011" cy="7.06177" rx="7.09011" ry="7" fill="#50C1BC" />
                  </svg>
                </span>
                Hurry Up! Only ${displayQty} in Stock
              `;
          } else if (inventoryElement) {
            inventoryElement.innerHTML = '';
          }
        }
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
        this.variantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriberForAddons?.();
        if (this._addOnSubmitSync) {
          document.removeEventListener('submit', this._addOnSubmitSync, true);
        }
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedElement = productInfoNode.querySelector('variant-selects [data-selected-variant]');
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        const productId = selectedElement?.dataset?.productId;
        const productType = selectedElement?.dataset?.productType;
        if (!selectedVariant) return null;
        const variant = JSON.parse(selectedVariant);
        if (productType === 'Ticket') {
          const selectedAddOns = productInfoNode.querySelector('variant-selects [data-product-add-ons]')?.innerHTML;
          if (selectedAddOns) {
            try {
              const addOnsData = JSON.parse(selectedAddOns);
              const addOnsArray = addOnsData?.event_add_ons;
              if (addOnsArray?.length) {
                this._pendingAddOnsSync = {
                  variant,
                  productId,
                  addOnsProductIds: addOnsArray.map((item) => item.id),
                };
              }
            } catch (e) {}
          }
        }
        return variant;
      }

      _syncAddOnFormOnSubmit(event) {
        const form = event.target;
        if (form.tagName !== 'FORM') return;
        const productFormEl = form.closest('product-form[data-add-on-product-id][data-parent-product-id]');
        if (!productFormEl) return;

        const mainProductInfo = document.querySelector('product-info variant-selects[data-product-add-ons]')?.closest('product-info');
        if (!mainProductInfo) return;

        const variantEl = mainProductInfo.querySelector('variant-selects [data-selected-variant]');
        if (!variantEl) return;

        let mainEventVariant;
        try {
          mainEventVariant = JSON.parse(variantEl.textContent.trim());
        } catch (e) {
          return;
        }
        const mainProductId = String(variantEl.dataset.productId || mainProductInfo.dataset.productId || '');
        const parentProductId = String(productFormEl.dataset.parentProductId || '');
        if (parentProductId !== mainProductId) return;

        const mainTitle = (mainEventVariant.title || '').trim();
        const mainPublicTitle = (mainEventVariant.public_title || mainTitle).trim();
        const displayTitle = mainPublicTitle || mainTitle;

        const mainDetailsInput = form.querySelector('input[name="properties[Main Event details]"]');
        if (mainDetailsInput) mainDetailsInput.value = displayTitle;
        const mainNameInput = form.querySelector('input[name="properties[Main Event Name]"]');
        if (mainNameInput) mainNameInput.value = mainProductInfo.dataset.productName || productFormEl.dataset.parentProductName || '';
        const mainEventKeyInput = form.querySelector('input[name="properties[_main_event_key]"]');
        if (mainEventKeyInput) {
          mainEventKeyInput.value = `${mainNameInput?.value || ''} - ${displayTitle}`;
        }

        const addOnProductId = productFormEl.dataset.addOnProductId;
        const addonScript = document.querySelector(`script[data-all-addon-variants][data-add-on-product-id="${addOnProductId}"]`);
        if (!addonScript) return;

        let addOnsVariants;
        try {
          addOnsVariants = JSON.parse(addonScript.textContent);
        } catch (e) {
          return;
        }
        if (!Array.isArray(addOnsVariants)) return;

        const idInput = form.querySelector('input[name="id"]');
        if (!idInput) return;

        const match = this.findMatchingAddOnVariant(mainEventVariant, addOnsVariants);
        if (match) idInput.value = match.id;
      }

      getEventDateKey(value) {
        const text = String(value || '').trim();
        if (!text) return '';
        const match = text.match(/([A-Za-z]+\s+\d{1,2},\s+\d{4})/);
        return String(match?.[1] || '').toLowerCase();
      }

      findMatchingAddOnVariant(mainEventVariant, addOnVariants) {
        if (!mainEventVariant || !Array.isArray(addOnVariants)) return null;
        const mainTitle = String(mainEventVariant.title || '').trim();
        const mainPublicTitle = String(mainEventVariant.public_title || mainTitle).trim();
        const exactMatch = addOnVariants.find((variant) => {
          const title = String(variant.title || '').trim();
          const publicTitle = String(variant.public_title || '').trim();
          return title === mainTitle || title === mainPublicTitle || publicTitle === mainTitle || publicTitle === mainPublicTitle;
        });
        if (exactMatch) return exactMatch;

        const exactOptionMatch = addOnVariants.find(
          (variant) => mainEventVariant.option1 && String(variant.option1 || '').trim() === String(mainEventVariant.option1).trim()
        );
        if (exactOptionMatch) return exactOptionMatch;

        const mainDateKey = this.getEventDateKey(mainEventVariant.option1 || mainTitle);
        if (!mainDateKey) return null;
        const sameDateMatches = addOnVariants.filter(
          (variant) => this.getEventDateKey(variant.option1 || variant.title) === mainDateKey
        );
        return sameDateMatches.length === 1 ? sameDateMatches[0] : null;
      }

      syncAddOnsToMainEventVariant(variantOverride) {
        const addOnsEl = this.querySelector('variant-selects [data-product-add-ons]');
        if (!addOnsEl) return;
        const variantSelects = addOnsEl.closest('variant-selects');
        if (variantSelects && variantSelects.dataset.productType !== 'Ticket') return;
        try {
          let variant = variantOverride;
          if (!variant) {
            const variantEl = this.querySelector('variant-selects [data-selected-variant]');
            if (!variantEl) return;
            variant = JSON.parse(variantEl.textContent.trim());
          }
          const addOnsData = JSON.parse(addOnsEl.textContent.trim());
          const addOns = addOnsData?.event_add_ons;
          if (!variant || !addOns?.length) return;
          const addOnsProductIds = addOns.map((item) => item.id);
          const productId = variantSelects ? variantSelects.dataset.productId : this.dataset.productId;
          this.changeAddOnsVariantId(variant, productId, addOnsProductIds);
        } catch (e) {
          console.error('Sync add-ons to main event variant:', e);
        }
      }

      setEventAddOnButtonsVisible(visible) {
        const btns = this.querySelectorAll('.event-add-on-submit-btn, button[data-event-add-on-submit]');
        btns.forEach((btn) => {
          btn.classList.toggle('hidden', !visible);
          btn.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }

      setEventAddOnButtonsVisibleFromCart(cartData) {
        const items = cartData?.items || [];
        const mainProductId = String(this.dataset.productId || '');
        const mainInCart = mainProductId && items.some((item) => String(item.product_id) === mainProductId);
        this.setEventAddOnButtonsVisible(!!mainInCart);
      }

      updateEventAddOnButtonsVisibilityFromCart() {
        if (this.dataset.productType !== 'Ticket') return;
        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => this.setEventAddOnButtonsVisibleFromCart(cart))
          .catch(() => this.setEventAddOnButtonsVisible(false));
      }

      changeAddOnsVariantId(mainEventVariant, productId, addOnsProductIds) {
        const productIdStr = String(productId || '');
        const mainTitle = (mainEventVariant?.title || '').trim();
        const mainPublicTitle = (mainEventVariant?.public_title || mainTitle).trim();
        const displayTitle = mainPublicTitle || mainTitle;
        if (!displayTitle) return;

        const allAddonElements = document.querySelectorAll('script[data-all-addon-variants]');
        allAddonElements.forEach((addon) => {
          const addOnProductId = addon.dataset.addOnProductId;
          if (!addOnProductId) return;
          let addOnsVariants;
          try {
            addOnsVariants = JSON.parse(addon.textContent);
          } catch (e) {
            return;
          }
          if (!Array.isArray(addOnsVariants)) return;

          const form = document.querySelector(`product-form[data-add-on-product-id="${addOnProductId}"][data-parent-product-id="${productIdStr}"]`);
          if (!form) return;

          const idInput = form.querySelector('input[name="id"]') || document.getElementById(`aaddon_product_id_${addOnProductId}`);
          const mainDetailsInput = form.querySelector('input[name="properties[Main Event details]"]');
          if (mainDetailsInput) mainDetailsInput.value = displayTitle;

          const matchedVariant = this.findMatchingAddOnVariant(mainEventVariant, addOnsVariants);
          if (matchedVariant && idInput) idInput.value = matchedVariant.id;

          form.dataset.eventVariantMatched = matchedVariant ? 'true' : 'false';
          const mainNameInput = form.querySelector('input[name="properties[Main Event Name]"]');
          if (mainNameInput) mainNameInput.value = form.dataset.parentProductName || this.dataset.productName || '';
          const mainEventKeyInput = form.querySelector('input[name="properties[_main_event_key]"]');
          if (mainEventKeyInput) {
            mainEventKeyInput.value = `${mainNameInput?.value || ''} - ${displayTitle}`;
          }

          const submitBtn = form.querySelector('.event-add-on-submit-btn, button[data-event-add-on-submit]');
          if (submitBtn) {
            submitBtn.disabled = !matchedVariant || !matchedVariant.available;
            const labelSpan = submitBtn.querySelector('span:first-child');
            if (labelSpan) {
              labelSpan.textContent = !matchedVariant
                ? 'Not available for selected event'
                : !matchedVariant.available
                  ? (window.productStrings?.soldOut || 'Sold out')
                  : (window.productStrings?.addToCart || 'Add to cart');
            }
          }
        });
      }


      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      } 

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('inventory-location-wrapper');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Description');

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          const newSubmitButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          const updatedProductForm = newSubmitButton?.closest('product-form');
          if (this.productForm && updatedProductForm) {
            this.productForm.dataset.eventSoldOutVariantIds = updatedProductForm.dataset.eventSoldOutVariantIds || '';
            const eventCheckout = this.productForm.querySelector('[data-event-dynamic-checkout]');
            if (eventCheckout) {
              eventCheckout.hidden = updatedProductForm.querySelector('[data-event-dynamic-checkout]')?.hidden ?? true;
            }
          }
          const isDisabled = newSubmitButton?.hasAttribute('disabled') ?? true;
          const buttonText = newSubmitButton?.querySelector('span')?.textContent?.trim();
          this.productForm?.toggleSubmitButton(
            isDisabled,
            isDisabled ? (buttonText || window.variantStrings.soldOut) : undefined
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          // Update add-on forms to match selected main event variant (defer so DOM/view transition has settled)
          if (variant && this.dataset.productType === 'Ticket') {
            const addOnsEl = this.querySelector('variant-selects [data-product-add-ons]');
            if (addOnsEl) {
              try {
                const addOnsData = JSON.parse(addOnsEl.textContent.trim());
                const addOns = addOnsData?.event_add_ons;
                if (addOns?.length) {
                  const addOnsProductIds = addOns.map((item) => item.id);
                  const productId = String(this.dataset.productId || '');
                  setTimeout(() => this.changeAddOnsVariantId(variant, productId, addOnsProductIds), 0);
                }
              } catch (e) {}
            }
          }
        };
      }

      // update variant input id
      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries(variantTitle) { 
        // const activeVariantRaw = this.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        // let currentVariantTitle = '';
        // if (activeVariantRaw) {
        //   try {
        //     const activeVariant = JSON.parse(activeVariantRaw);
        //     currentVariantTitle = activeVariant.title?.toLowerCase().replace(/\|/g, '').trim() || '';
        //   } catch (error) {
        //     console.error('Error parsing activeVariant JSON:', error);
        //   }
        // }
        // const isCurrentCaseVariant = currentVariantTitle === 'case';
        // const rawMin = isCurrentCaseVariant ? 12 : (this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1);
        
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        // const selectedVariantRaw = this.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        // let variantTitle = '';
        // if (selectedVariantRaw) {
        //   try {
        //     const selectedVariant = JSON.parse(selectedVariantRaw);
        //     variantTitle = selectedVariant.title?.toLowerCase().replace(/\|/g, '').trim() || '';
        //   } catch (error) {
        //     console.error('Error parsing selectedVariant JSON:', error);
        //   }
        // }
        // const isCaseVariant = variantTitle === 'case';

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              // Special handling for case variant
              // if (isCaseVariant && ['step'].includes(attribute)) {
              //   current.setAttribute(attribute, '12');
              // } else {
                const valueUpdated = updated.getAttribute(attribute);
                if (valueUpdated !== null) {
                  current.setAttribute(attribute, valueUpdated);
                } else {
                  current.removeAttribute(attribute);
                }
              // }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
